import { Head } from 'vite-react-ssg';

// TODO (owner): swap the "Contact sales for pricing" stub for real pricing / tiers if approved.
// TODO (owner): the previous aggregateRating was a placeholder — re-add only with verified data
// (G2, Capterra, TrustRadius). Publishing fake ratings is a legal and policy risk.
const schema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  '@id': 'https://ezcloud.ai/#product',
  name: 'EZ Cloud',
  applicationCategory: 'BusinessApplication',
  applicationSubCategory: 'Accounts Payable Automation',
  operatingSystem: 'Cloud',
  description:
    'AI-powered accounts payable automation with AI invoice capture, prebuilt ERP integration, exception prevention, and touchless approvals.',
  url: 'https://ezcloud.ai/',
  softwareRequirements:
    'Compatible with Oracle Cloud ERP (Fusion), Oracle EBS, NetSuite, Yardi Voyager, JDE, SAP, and Microsoft Dynamics.',
  audience: {
    '@type': 'Audience',
    audienceType: 'Mid-market and enterprise finance teams',
  },
  publisher: { '@id': 'https://ezcloud.ai/#organization' },
  provider: { '@id': 'https://ezcloud.ai/#organization' },
  isPartOf: { '@id': 'https://ezcloud.ai/#website' },
  offers: {
    '@type': 'Offer',
    availability: 'https://schema.org/InStock',
    priceCurrency: 'USD',
    priceSpecification: {
      '@type': 'PriceSpecification',
      priceCurrency: 'USD',
      description: 'Contact sales for pricing',
    },
    url: 'https://outlook.office.com/bookwithme/user/ca2e84f5d95b4280a34073c39ee722f3@ezcloud.ai/meetingtype/cGjhRG1JmkSrBrj2cFWWjA2?anonymous&ismsaljsauthenabled&ep=mlink',
  },
  featureList: [
    'AI Email Exception Prevention',
    'Prebuilt ERP Integration',
    'Multi-Channel Invoice Capture',
    'Automated Approval Workflows',
    '3-Way Match',
    'Real-time Analytics',
  ],
};

const SoftwareApplicationSchema = () => (
  <Head>
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
  </Head>
);

export default SoftwareApplicationSchema;
